// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__16hvc","title":"AfterFrontImage_title__2HLN_"};